<template>
  <div class="tech-transformation">
    <div class="title">
      <svg-icon icon-name="home-tech" :size="20" class="mr-5"></svg-icon>
      <span>{{ $t('clientDashboard.tech_transformation') }}</span>
    </div>
    <div class="content">
      <div v-for="(item, index) in dataList" :key="index" class="item" @click="openLink(item.linkUrl)" :title="item.name">
        <img :src="item.imgSrc" :alt="item.name">
        <el-tooltip :content="item.name" placement="top" :popper-class="getIfClientDrawerTag ? 'el-tooltip-drawer' : ''">
          <div class="name">{{ item.name }}</div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SvgIcon from "@/components/svgIcon/index";

import { techTransformationList } from './data'

export default {
  name: 'MidPolicy',
  components: {
    SvgIcon
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('common', {
      getIfClientDrawerTag: 'getIfClientDrawerTag',
    }),
    dataList() {
      return [...techTransformationList[this.$i18n.locale]].splice(0, 6)
    },
  },
  methods: {
    openLink(url) {
      window.open(url)
    },
  }
}
</script>

<style scoped>
.tech-transformation {
  height: 100%;
  padding-left: var(--spacing);

  --spacing: 15px;
  --title-height: 46PX;
}

.tech-transformation .title {
  height: var(--title-height);
  display: flex;
  align-items: center;
  font-weight: 600;

  font-size: 15PX;
}

.tech-transformation .content {
  display: flex;
  flex-wrap: wrap;
  height: calc(100% - var(--title-height));
}

.tech-transformation .content .item {
  width: calc((100% - var(--spacing) * 3) / 3);
  height: calc((100% - var(--spacing) * 2) / 2);
  margin-right: var(--spacing);
  margin-bottom: var(--spacing);
  cursor: pointer;
}

.tech-transformation .content .item img {
  width: 100%;
  height: calc(100% - 30px);
  object-fit: cover;
  border-radius: 10px;
}

.tech-transformation .content .item .name {
  height: 30px;
  line-height: 30px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>